import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import SupplierIndexPage from '../containers/Suppliers'
import SupplierShowPage from '../containers/Suppliers/show'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const SuppliersPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'suppliers') {
			dispatch(changeCurrent(['suppliers']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={SupplierIndexPage} exact />
      <Route path={`${path}/:id`} component={SupplierShowPage} />
		</Switch>
  )
}

SuppliersPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

SuppliersPage.defaultProps = {}

export default SuppliersPage
